module.exports = __webpack_public_path__ + "static/img/yewei.e0a8de8b.png";